
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import { Card } from "rsuite";

import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { Document, Page } from 'react-pdf';
import { usePDF } from 'react-to-pdf';
import HeaderOfPage from "../tools/headerOfPage";


export default function InvoiceDetial() {
    const { t } = useTranslation();
    const [key, setKey] = useState<any>(1);
    const [numPages, setNumPages] = useState(null);

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'َکاربران',
            url: '/dashboard/user'
        },
        {
            name: 'لیست فاکتور',
            url: '/dashboard/user/invoices'
        },
        {
            name: ' فاکتورها',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }



    return (
        <>
            <div className="text-left directions  bg-white  p-3 m-4   h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="فاکتور"></HeaderOfPage>

               
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">

                    <div className="col-span-3">
                        <ListofBlog key={key}></ListofBlog>
                    </div>
                </div>
            </div>

        </>
    )
}
function ListofBlog() {
    const { t } = useTranslation();
    let { Id } = useParams();

    let cookie = getCookies();
    const [invoice, setList] = useState<any>(null);
    const [page, setPage] = useState<any>(1);
    const { toPDF, targetRef } = usePDF({ filename: 'invoice.pdf' });

    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);

    const [pageNumber, setPageNumber] = useState<number>(1);
    const [numPages, setNumPages] = useState<number>();

    const getalldata = async () => {
        setError(null);
        
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/invoices/' + Id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            //let mydata = res.data;
            //  console.log(config.url + '/v1/dashboard/bloggroup')
            //  console.log(res);
            setList(res.data.message);
        } catch (error: any) {

            // error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            //  setError(error.response.data.message.errors);
        }
    }
    const update = async (status: any) => {

        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/invoices/' + Id,
                data: {
                    status: status
                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            //let mydata = res.data;
            //  console.log(config.url + '/v1/dashboard/bloggroup')
            //  console.log(res);
            getalldata();
        } catch (error: any) {

            // error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            //  setError(error.response.data.message.errors);
        }
    }
    const deleted = async (id: any) => {

        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/menus/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata();
                } catch (error) {
                    Swal.fire(t('Can not be to deleted, this item have submenu'))
                }
            }
        });

    }
    const toJalali = (date: string) => {
        const utcDate = new Date(date);
        const localDate = utcDate.toLocaleString('fa-IR', {

            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'

        }); // Converts to local time
        return localDate;


    }
    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }
    useEffect(() => {
        getalldata();
    }, []);
    return (
        <div className="directions text-right" dir="rtl">
            <div className="flex flex-col md:flex-row justify-between items-center pb-4 gap-3">
                <div>
                    {/* left side reserved for future filters if needed */}
                </div>
                <div className="flex gap-3 w-full justify-end">
                    {invoice != null && (
                        <a
                            href={`/dashboard/User/invoicesprice/${invoice.id}`}
                            className="py-2.5 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-green-500 text-white hover:bg-green-600 focus:outline-none disabled:opacity-50 disabled:pointer-events-none"
                        >
                            <img src="/icons/print.svg" width={12} alt="print" />
                            {t('چاپ لیبل ارسال')}
                        </a>
                    )}
                </div>
            </div>

            {invoice && (
                <div ref={targetRef} className="bg-white rounded-xl shadow-sm p-6 space-y-6 text-right">
                    {/* Invoice header */}
                    <div className="flex flex-col md:flex-row justify-between gap-4 border-b border-gray-100 pb-4" dir="rtl">
                        <div>
                            <h1 className="text-xl font-bold text-gray-800">فاکتور فروش</h1>
                            <p className="text-xs text-gray-500 mt-1">شماره فاکتور: {invoice.id}</p>
                            <p className="text-xs text-gray-500">تاریخ صدور: {toJalali(invoice.createdAt)}</p>
                        </div>
                        <div className="flex flex-col items-start md:items-end gap-2">
                            <div className="flex items-center gap-2">
                                <span className="text-xs text-gray-500">وضعیت:</span>
                                <select
                                    value={invoice.status}
                                    onChange={(e) => update(e.target.value)}
                                    className="text-xs border border-gray-300 rounded-lg px-2 py-1 bg-white focus:outline-none focus:border-blue-500"
                                >
                                    <option value={"pending"}>در حال بررسی</option>
                                    <option value={"paid"}>پرداخت شده</option>
                                    <option value={"canceled"}>کنسل</option>
                                    <option value={"sending"}>در حال ارسال</option>
                                    <option value={"archive"}>بایگانی</option>
                                </select>
                            </div>
                            <div className="text-sm font-semibold text-gray-800">
                                مبلغ کل: {invoice.totalprice.toLocaleString('fa-IR')} تومان
                            </div>
                            <div className="text-xs text-gray-500">
                                نحوه پرداخت: {invoice.paymentmode == "1" && "پرداخت آنلاین"}
                            </div>
                        </div>
                    </div>

                    {/* Customer & address */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        <div className="space-y-1">
                            <h3 className="text-sm font-semibold text-gray-800 mb-1">مشخصات خریدار</h3>
                            {invoice.touser && (
                                <>
                                    <p>نام: {invoice.touser.name}</p>
                                    <p>نام خانوادگی: {invoice.touser.lastname}</p>
                                    {invoice.touser.nationalcode && <p>کدملی: {invoice.touser.nationalcode}</p>}
                                </>
                            )}
                            {invoice.address && invoice.address.phone && (
                                <p>شماره تماس: {invoice.address.phone}</p>
                            )}
                        </div>
                        <div className="space-y-1">
                            <h3 className="text-sm font-semibold text-gray-800 mb-1">آدرس ارسال</h3>
                            {invoice.address && (
                                <>
                                    <p>استان: {invoice.address.provinces}</p>
                                    <p>شهر: {invoice.address.city}</p>
                                    <p>آدرس: {invoice.address.address}</p>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Items table */}
                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                        <div className="bg-gray-50 px-4 py-2 text-sm font-semibold text-gray-700">
                            اقلام فاکتور
                        </div>
                        <div className="overflow-x-auto">
                            <table className="min-w-full text-xs text-right">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-2 font-medium text-gray-600">محصول</th>
                                        <th className="px-4 py-2 font-medium text-gray-600">آیتم</th>
                                        <th className="px-4 py-2 font-medium text-gray-600">تعداد</th>
                                        <th className="px-4 py-2 font-medium text-gray-600">قیمت واحد</th>
                                        <th className="px-4 py-2 font-medium text-gray-600">قیمت کل</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoice.details.map((detail: any, i: number) =>
                                        detail.detail.item.map((it: any, j: number) => (
                                            <tr key={`${i}-${j}`} className="border-b border-gray-100 hover:bg-gray-50">
                                                <td className="px-4 py-2">{detail.product.name}</td>
                                                <td className="px-4 py-2">{it.name}</td>
                                                <td className="px-4 py-2">{it.count}</td>
                                                <td className="px-4 py-2">{it.price.toLocaleString('fa-IR')} تومان</td>
                                                <td className="px-4 py-2">
                                                    {(it.price * it.count).toLocaleString('fa-IR')} تومان
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Payments history */}
                    {invoice.topayment && invoice.topayment.length > 0 && (
                        <div className="border border-gray-200 rounded-xl p-4 text-sm space-y-2 text-right">
                            <h3 className="text-sm font-semibold text-gray-800 mb-2">تاریخچه پرداخت</h3>
                            <div className="grid gap-3">
                                {invoice.topayment.map((item: any, idx: number) => (
                                    <div
                                        key={idx}
                                        className={`rounded-lg p-3 text-xs ${
                                            item.verify ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'
                                        }`}
                                    >
                                        <div className="font-semibold mb-1">
                                            {item.verify ? 'پرداخت موفق' : 'پرداخت ناموفق'}
                                        </div>
                                        {item.verify && item.data?.data && (
                                            <>
                                                <div>Ref Id: {item.data.data.ref_id}</div>
                                                <div>شماره کارت: {item.data.data.card_pan}</div>
                                            </>
                                        )}
                                        <div>تاریخ: {toJalali(item.createdAt)}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Attached image */}
                    {invoice.attached && (
                        <div className="border border-gray-200 rounded-xl p-4">
                            <h3 className="text-sm font-semibold text-gray-800 mb-2">ضمائم</h3>
                            <img src={config.url + invoice.attached} alt="attachment" className="max-h-64 object-contain" />
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
